import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import ForgottenForm from "./ForgottenForm"
import { recoverUsername, requestPasswordReset } from "../../redux/actions/authActions"
import { toast } from "react-toastify"; 


function ForgottenPage({
    auth,
    errorMessage,
    history, 
    ...props
}) {

    const [email, setEmail] = useState("");
    const [errors, setErrors] = useState({});
    const [processing, setProcessing] = useState(false);

    useEffect(() => {
        if (auth.isAuthenticated) {
            history.push("/");
        }
        document.title = "Forgotten Something? | JustGoRide";
    }, []);

    function formIsValid() {
        const errors = {};

        if (!email) {
            errors.email = "Email address is required.";
            setErrors(errors);
            return false;
        } else if (!/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
            errors.email = "Email address format invalid";
            setErrors(errors);
            return false;
        }

        return true;
    }

    function handleChange(event) {
        setErrors({});
        const emailValue = event.target.value;
        setEmail(emailValue);

    }

    function handleReset(event) {
        event.preventDefault();

        if (!formIsValid()) return;
        requestPasswordReset(email);
        toast.success("Password reset email sent!");
        history.push("/login");
        
    }


    function handleRecover(event) {
        event.preventDefault();

        if (!formIsValid()) return;
        //alert('Recover: ' + email);
        recoverUsername(email);
        toast.success("Username reminder email sent!");
        history.push("/login");

    }


    return (
        <div className="jgr-forgotten">
            <ForgottenForm
                email={email}
                errors={errors}
                onChange={handleChange}
                onReset={handleReset}
                onRecover={handleRecover}
                processing={processing}
                />
        </div>
    );

}

ForgottenPage.propTypes =
    {
        auth: PropTypes.object.isRequired,
        errorMessage: PropTypes.string
    }


function mapStateToProps(state) {
    return {
        auth: state.auth
    };
}

const mapDispatchToProps = {

}

export default connect(mapStateToProps, mapDispatchToProps)(ForgottenPage); 


// WEBPACK FOOTER //
// ./src/components/user/ForgottenPage.js